import { $ZodErrorMap } from 'zod/v4/core';

const customErrorMap: $ZodErrorMap = (issue) => {
  if (issue.code === 'too_small' && issue.value === 1) {
    return 'Is required field';
  }
  if (issue.code === 'invalid_type') {
    return 'Is required field';
  }
  if (issue.code === 'too_small') {
    return `Must contain at least ${issue.minimum} character(s)`;
  }
  return issue.message;
};

export default customErrorMap;
